import { useQuery } from 'villus';
import { VcxLandingPageQuery, VcxLandingPageFooterQuery } from '@sanity/graphql/queries/vcx-landing-page';
import { flattenSharedFooterDisclaimers } from '@utils/sanity';
import { villusClient } from '@utils/villus';
import { FooterDisclaimerItem, SanityGraphQLResponse, SanityRichTextBlock } from 'types/sanity';
import { VcxLandingPageData } from 'types/sanity/vcx-landing-page';

type SanityVcxLandingPageResponse = SanityGraphQLResponse<VcxLandingPageData, 'allVcxLandingPage'>;

type SanityVcxLandingFooterResponse = SanityGraphQLResponse<
	{ vcxFooterDisclaimers?: Array<FooterDisclaimerItem> },
	'allVcxLandingPage'
>;

export async function getVcxLandingPage(): Promise<VcxLandingPageData | null> {
	const { data } = await useQuery<SanityVcxLandingPageResponse>({
		client: villusClient,
		query: VcxLandingPageQuery,
		tags: ['vcx_landing_page']
	}).execute();

	const vcxLandingPage = data?.allVcxLandingPage?.[0] ?? null;

	if (!vcxLandingPage) return null;

	// empty arrays in sanity are served as null - make them null-safe
	vcxLandingPage.vcxPortfolioDescription = vcxLandingPage.vcxPortfolioDescription ?? [];
	vcxLandingPage.vcxPortfolioHoldings = vcxLandingPage.vcxPortfolioHoldings ?? [];
	vcxLandingPage.vcxSectorBreakdown = vcxLandingPage.vcxSectorBreakdown ?? [];
	vcxLandingPage.vcxPrivatePublicBreakdown = vcxLandingPage.vcxPrivatePublicBreakdown ?? [];
	vcxLandingPage.vcxPerformanceData = vcxLandingPage.vcxPerformanceData ?? [];
	vcxLandingPage.vcxFeaturedArticles = vcxLandingPage.vcxFeaturedArticles ?? [];
	vcxLandingPage.vcxFeaturedPodcasts = vcxLandingPage.vcxFeaturedPodcasts ?? [];

	return vcxLandingPage;
}

export async function getVcxFooter(): Promise<Array<SanityRichTextBlock>> {
	const { data } = await useQuery<SanityVcxLandingFooterResponse>({
		client: villusClient,
		query: VcxLandingPageFooterQuery,
		tags: ['vcx_landing_footer']
	}).execute();

	const vcxLandingPageFooter = data?.allVcxLandingPage?.[0]?.vcxFooterDisclaimers ?? null;
	return flattenSharedFooterDisclaimers(vcxLandingPageFooter ?? []);
}
